import React from 'react';

import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LoadingIndicator = () => (<div style={{ width: '36px' }}> <FontAwesomeIcon icon={faEllipsis} beatFade size="2x" /></div>);
